declare const window
// TODO(DG-2312): remove reference to window.view

export type PrivacyOptions = {
  shouldShowDnsLink?: boolean
}

export const getInitialState = (initialState): PrivacyOptions => ({
  shouldShowDnsLink:
    initialState.showDoNotSellBanner ||
    (window.view && window.view.showDoNotSellBanner),
})
